import React, { Suspense, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { getConfig } from "./components/config/CookieConsentConfig";

import "./App.css";
import "./assets/styles/cookie-consent.module.css";
import {
  Masthead,
  About,
  Header,
  Footer,
  Specialities,
  Contacts,
  Protocols,
  ContactsModal,
} from "./components";

const useIntersection = (element, rootMargin) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const current = element?.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      { rootMargin }
    );
    current && observer?.observe(current);

    return () => current && observer.unobserve(current);
  }, []);

  return isVisible;
};

function App() {
  const contactsRef = React.useRef(null);
  const isContactsVisible = useIntersection(contactsRef, "0px");

  const [showPortugueseFlag, setShowPortugueseFlag] = useState(false);
  const { t, i18n } = useTranslation("common");

  const handleLanguageClick = () => {
    let language = !showPortugueseFlag ? "en" : "pt";
    i18n.changeLanguage(language);
    setShowPortugueseFlag(!showPortugueseFlag);
    CookieConsent.setLanguage(language);
  };

  useEffect(() => {
    CookieConsent.run(getConfig());
  }, [showPortugueseFlag]);

  return (
    <Suspense fallback="loading">
      <Header
        isEnglish={showPortugueseFlag}
        handleLanguageClick={handleLanguageClick}
      />
      <Masthead />
      <About />
      <Specialities />
      <Protocols />
      <ContactsModal isHidden={isContactsVisible} />
      <div ref={contactsRef}><Contacts /></div>
      <Footer />
    </Suspense>
  );
}

export default App;
